/**
 * @generated SignedSource<<affad9e0d88913d526673792471b2239>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ServiceType = "GROUP" | "SOLO";
import { FragmentRefs } from "relay-runtime";
export type ServiceRow_service$data = {
  readonly id: string;
  readonly name: string;
  readonly price: ReadonlyArray<number> | null;
  readonly type: ServiceType | null;
  readonly " $fragmentSpreads": FragmentRefs<"SortableEntityTableRow_entity">;
  readonly " $fragmentType": "ServiceRow_service";
};
export type ServiceRow_service$key = {
  readonly " $data"?: ServiceRow_service$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceRow_service">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServiceRow_service",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SortableEntityTableRow_entity"
    }
  ],
  "type": "Service",
  "abstractKey": null
};

(node as any).hash = "7550108d30ef440665c1531f55aa2de3";

export default node;
